// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let Sentry = require("../../reason/Sentry.bs.js");
let PageTitle = require("../../reason/common/PageTitle.bs.js");
let DashboardHero = require("../../reason/dashboard/DashboardHero.bs.js");
let LoggedInAgent = require("../../reason/common/UserSession/LoggedInAgent.bs.js");
let MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let ClientStatsWidget = require("./ClientStatsWidget.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let NotificationWidgetRelay = require("../../modules/Notification/components/NotificationWidgetRelay.bs.js");
let HomeDashboardPageQuery_graphql = require("../../__generated__/HomeDashboardPageQuery_graphql.bs.js");

let convertVariables = HomeDashboardPageQuery_graphql.Internal.convertVariables;

let convertResponse = HomeDashboardPageQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = HomeDashboardPageQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, HomeDashboardPageQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, HomeDashboardPageQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(HomeDashboardPageQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(HomeDashboardPageQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(HomeDashboardPageQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(HomeDashboardPageQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function HomeDashboardPage$Widgets$WithoutErrorBoundary(props) {
  let data = use(undefined, undefined, undefined, undefined);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(MarkupHelpers.Container.make, {
      className: "pt-4 pb-4 md:pt-8 md:pb-8 lg:pt-10 lg:pb-10",
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(NotificationWidgetRelay.make, {
            query: data.fragmentRefs,
            showMore: true
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ClientStatsWidget.make, {
              query: data.fragmentRefs
            }),
            className: "mt-8"
          })
        ],
        className: "p-5 bg-white shadow rounded"
      })
    })
  });
}

let WithoutErrorBoundary = {
  make: HomeDashboardPage$Widgets$WithoutErrorBoundary
};

function HomeDashboardPage$Widgets(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => null,
    children: JsxRuntime.jsx(HomeDashboardPage$Widgets$WithoutErrorBoundary, {}),
    onError: error => Sentry.captureException(error, "HomeDashboardPage.res", undefined, undefined, undefined)
  });
}

let Widgets = {
  Query: Query,
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: HomeDashboardPage$Widgets
};

function HomeDashboardPage$default(props) {
  return JsxRuntime.jsx(LoggedInAgent.Provider.make, {
    loaderComponent: JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(PageTitle.make, {
          title: `Loading...`
        }),
        JsxRuntime.jsx(Loader.make, {})
      ]
    }),
    children: JsxRuntime.jsx(React.Suspense, {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(DashboardHero.make, {}),
          JsxRuntime.jsx(HomeDashboardPage$Widgets, {})
        ]
      }),
      fallback: JsxRuntime.jsx(Loader.make, {})
    })
  });
}

let $$default = HomeDashboardPage$default;

exports.Widgets = Widgets;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
